import { render, staticRenderFns } from "./ManagementEntityStatsProject.vue?vue&type=template&id=5ecaab04&scoped=true&"
import script from "./ManagementEntityStatsProject.vue?vue&type=script&lang=js&"
export * from "./ManagementEntityStatsProject.vue?vue&type=script&lang=js&"
import style0 from "./ManagementEntityStatsProject.vue?vue&type=style&index=0&id=5ecaab04&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ecaab04",
  null
  
)

export default component.exports